import React, { useEffect, useState } from 'react';
import { ToastContainer, toast } from 'react-toastify';

import ReportDetailsModal from './ReportDetailsModal';

import { useSignalRConnection } from 'utils/useSignalRConnection';
import { showEmergencyNotificationCountOnFavicon } from 'utils';
import { ENV } from '../../../../constants';
import 'react-toastify/dist/ReactToastify.css';
import './index.css';

export interface IEmergencyReportProps {
  isFcaUser: boolean;
  isAdmin: boolean;
  isAuthenticated: boolean;
  userId: string;
  companyUserId: string;
}

const EmergencyReport = ({ isAdmin, isFcaUser, isAuthenticated, userId, companyUserId }: IEmergencyReportProps) => {
  const [toasts, setToasts] = useState([]);
  const [activeToast, setActiveToast] = useState(null);

  const connection = useSignalRConnection({
    url: ENV.API.URL + '/reportemergencyhub',
    connectionCondition: isAuthenticated,
    connectionKey: 'EmergencyMessage',
    onMessageReceive: (users: string[], message) => {
      const data = typeof message === 'string' ? JSON.parse(message) : message;
      if ((isFcaUser && isAdmin) || users?.includes(companyUserId) || users?.includes(userId)) {
        setToasts(prevToasts => [...prevToasts, { ...(data || {}) }]);
        toast.error(data.messageText, {
          theme: 'colored',
          toastId: data.id,
          onClick: () => {
            setActiveToast(data);
          },
          onClose: () =>
            setToasts(prevToasts => {
              const deleteIndex = prevToasts.findIndex(({ id }) => id === data.id);
              return deleteIndex !== -1 ? [...prevToasts.slice(0, deleteIndex), ...prevToasts.slice(deleteIndex + 1)] : prevToasts;
            }),
        });
      }
    },
  });

  useEffect(() => {
    showEmergencyNotificationCountOnFavicon(toasts.length);
  }, [toasts]);

  useEffect(() => {
    if (!isAuthenticated) {
      toast.dismiss();
      if (connection) {
        connection.stop();
      }
    }
  }, [isAuthenticated, connection]);

  const onCloseToast = () => {
    toast.dismiss(activeToast.id);
    setActiveToast(null);
  };

  return <>{activeToast && <ReportDetailsModal data={activeToast} closeModal={onCloseToast} />}</>;
};

export default EmergencyReport;
